import React from 'react';
import PropTypes from 'prop-types';

import ItemViewTop from "../../../../../../layout/top/item-view-top/item-view-top";
import AddCustomFieldHeader from "../components/header";
import AddCustomFieldGroup from "../components/fields-group";
import CUSTOM_FIELDS_V1, {CUSTOM_FIELDS_V1_LIST} from "../../../../../gd/const/fields/custom-fields-v1";
import {FieldType} from "../../../../../fields3/field-type";
import VScroll from "../../../../../gd-components/scrolling/custom-v-scroll/v-scroll";

export default class Step1SelectCustomFieldType extends React.Component<any> {

    static propTypes = {
        onSelectType: PropTypes.func.isRequired,
        onCloseClick: PropTypes.func,
    }

    onClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    }

    getFieldTypes = () => {

        const fieldTypes:any[] = [];
        CUSTOM_FIELDS_V1_LIST.map(id=>{
            const cf = gd.const.customFields[id];
            fieldTypes.push({
                id:             cf.id,
                icon:           cf.icon,
                name:           cf.label,
                group:          cf.group,
                color:          gd.const.customFields.getGroupColor(cf.group),
                description:    cf.description
            });
        });

        const groupsOrder:any[] = [];
        _.mapKeys(gd.const.customFields.groups,(value,key)=>groupsOrder.push(key))

        const result = _.chain(fieldTypes)
            .groupBy(t=>t.group)
            .toPairs()
            .map(group=>({
                id: group[0],
                name: gd.const.customFields.groupLabel[group[0]],
                items: group[1]
            }))
            .sortBy(group=>_.indexOf(groupsOrder, group.id))
            .value();

        // // Temp patch - custom inject Reaction from Field 3
        // result[5].items.push(
        //     {
        //         id: FieldType.REACTION,
        //         label: 'Reaction',
        //         icon: 'i5-color',
        //         className: 'color',
        //         group: 'misc',
        //         description: 'Reaction'
        //     }
        // )

        return result
    }

    render() {
        const groupedItems = this.getFieldTypes();

        return (
            <div className="v4-container placement-middle ui5-iv view-custom-field-selector" style={{width: 840}} onClick={this.onClick}>
                <ItemViewTop title="New custom field" onCloseClick={this.props.onCloseClick}/>

                <div className="iv-selector">
                    <VScroll>
                        <AddCustomFieldHeader/>

                        <div className="iv-content without-left-panel iv-paddings">
                            {_.map(groupedItems, group=><AddCustomFieldGroup key={group.id}
                                                                             name={group.name}
                                                                             items={group.items}
                                                                             onSelectType={this.props.onSelectType}/>)}
                        </div>
                    </VScroll>
                </div>
            </div>
        )
    }
}
